export const getTagFormatMessageValues = (tags: string[]) => {
	const tagSuffixes = ['Start', 'End'];
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	return tags.reduce<Record<string, any>>((accumulator, tag) => {
		tagSuffixes.forEach((suffix) => {
			accumulator[`${tag}${suffix}`] = `{${tag}${suffix}}`;
		});
		return accumulator;
	}, {});
};
